import { ChevronRight } from 'lucide-react';

interface RefineDrillInRowProps {
    title: string;
    /** Staged-value summary shown muted before the chevron. */
    summary?: string;
    onClick: () => void;
}

/**
 * A `>` row navigating to an in-sheet sub-view. The chevron is reserved for
 * navigation, and the staged summary keeps applied state legible without
 * opening the door.
 */
export const RefineDrillInRow = (props: RefineDrillInRowProps) => {
    const { title, summary, onClick } = props;

    return (
        <button
            type="button"
            onClick={onClick}
            className="flex min-h-11 w-full cursor-pointer items-center justify-between gap-3 border-b border-gray-900/10 text-left"
        >
            <span className="shrink-0 text-sm font-medium">{title}</span>
            <span className="flex min-w-0 items-center gap-2">
                {summary && (
                    <span className="truncate text-sm text-gray-400">
                        {summary}
                    </span>
                )}
                <ChevronRight
                    aria-hidden
                    className="size-4 shrink-0 text-gray-400"
                />
            </span>
        </button>
    );
};
